import { ApiListResponse } from "@/types/api-response.model";
import { EmployeeData } from "@/types/employee.interfaces";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
  export class EmployeeService {
    private http = inject(HttpClient);
    private readonly apiUrl = `/api/employee`;

    getAllEmployees(): Observable<ApiListResponse<EmployeeData>> {
        return this.http.get<ApiListResponse<EmployeeData>>(this.apiUrl);
      }
  }
